import { Pipe, PipeTransform } from '@angular/core';
import { ApplicantInKindItem } from '@features/in-kind/in-kind.typing';

@Pipe({
    name: 'gcInKindNumberOfUnits',
    standalone: false
})
export class InKindNumberOfUnitsPipe implements PipeTransform {

  transform (
    inKindItems: Partial<ApplicantInKindItem>[] = []
  ) {
    return (inKindItems || []).reduce((acc, item) => {
      return acc + item.count;
    }, 0);
  }
}
